import React, { useEffect } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Grid, InputLabel, Tooltip } from "@mui/material";
import useStyles from "../../../components/common/model/styles";
import { FormFieldProps } from "../../../utils/formFields";

const CKEditorComponent: React.FC<FormFieldProps> = (props) => {
  const classes = useStyles();
  const hideToolbar = props?.editorConfig?.hideFontControls ?? false;

  useEffect(() => {
    const savedData = localStorage.getItem(props.id);
    if (savedData) {
      props.onChange && props.onChange(savedData);
    }
  }, [props.id]);

  const handleBlur = () => {
    props.onBlur &&
      props.onBlur({ target: { id: props.id, value: props.value } });
  };

  const handleFocus = () => {
    props.onFocus &&
      props.onFocus({ target: { id: props.id, value: props.value } });
  };

  const inputRender = () => {
    return (
      <CKEditor
        editor={ClassicEditor}
        config={{
          toolbar: {
            items: hideToolbar
              ? []
              : [
                  "heading",
                  "|",
                  "fontFamily",
                  "fontSize",
                  "fontColor",
                  "fontBackgroundColor",
                  "|",
                  "bold",
                  "italic",
                  "underline",
                  "strikethrough",
                  "|",
                  "alignment",
                  "horizontalLine",
                  "|",
                  "numberedList",
                  "bulletedList",
                  "|",
                  "outdent",
                  "indent",
                  "|",
                  "link",
                  "blockquote",
                  "insertTable",
                  "|",
                  "undo",
                  "redo",
                ],
          },
        }}
        data={props?.value}
        onChange={(event: any, editor: any) => {
          const data = editor.getData();
          props?.onChange && props?.onChange(data);
        }}
        onReady={(editor: any) => {
          if (hideToolbar) {
            const toolbarElement = editor.ui.view.toolbar.element;
            if (toolbarElement) {
              toolbarElement.style.display = "none";
            }
            return;
          }

          const toolbarElement = editor.ui.view.toolbar.element;
          const editableElement = editor.ui.getEditableElement();
          if (toolbarElement && editableElement) {
            editableElement.parentElement?.insertBefore(
              toolbarElement,
              editableElement
            );
          }
        }}
        onBlur={handleBlur} // Pass onBlur event handler
        onFocus={handleFocus} // Pass on focus event handler
      />
    );
  };

  return (
    <>
      {props?.label && !props?.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={2.5}
            className={props.id === "signature" ? "" : classes.labelBox}
          >
            {props.id !== "signature" && (
              <InputLabel
                sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
                shrink
                htmlFor={props?.id}
              >
                {props?.label}
                {props?.isRequired && (
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            )}
          </Grid>

          <Grid
            item
            xs={12}
            sm={9.5}
            style={{
              padding: "0px",
              marginTop: props.id !== "signature" ? "16px" : "0px",
            }}
          >
            <div
              className={props.error ? "ckeditor-error" : ""}
              id={props?.id}
              onMouseUp={props?.onMouseUp}
              onKeyUp={props?.onKeyUp}
            >
              {inputRender()}
            </div>
          </Grid>
        </>
      ) : props?.label && props?.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 12}
            sx={{
              display: "block",
              alignItems: "center",
              gap: 2,
              ...props?.GridFieldStyle,
            }}
          >
            <Tooltip title={props?.tooltipText || ""} arrow>
              <InputLabel
                sx={{
                  color: "#637381",
                  fontWeight: 600,
                  fontSize: "16px",
                  textAlign: "left !important",
                }}
                shrink
                htmlFor={props?.id}
              >
                {props?.label}
                {props?.isRequired && (
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            </Tooltip>
            {inputRender()}
          </Grid>
        </>
      ) : (
        <div
          style={{ width: "100%", marginBottom: "10px" }}
          className={props.error ? "ckeditor-error" : ""}
          id={props?.id}
          onMouseUp={props?.onMouseUp}
          onKeyUp={props?.onKeyUp}
        >
          {inputRender()}
        </div>
      )}
    </>
  );
};

export default CKEditorComponent;
